import { render, staticRenderFns } from "./HomeScreenConfig.vue?vue&type=template&id=318838ab&"
import script from "./HomeScreenConfig.vue?vue&type=script&lang=js&"
export * from "./HomeScreenConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports